// extracted by mini-css-extract-plugin
export default {"introWrapper":"intro_introWrapper__qNL0U","intro":"intro_intro__h55zm","mySelfWrapper":"intro_mySelfWrapper__x2VXG","post":"intro_post__SXZGc","mySelf":"intro_mySelf__kbPiU"};